import {writable} from 'svelte/store';

let locationsObject = {
    tree: null,
    title: "Επιλογή Περιοχής",
    selected: null,
    allow_edit: false,
    hidden_locations: null,
    multy_select: false,
    callback: null,

    edit_id: null,
};

const {get, set, update, subscribe} = writable(locationsObject)

const locationsStore = {
    subscribe,
    update,
    set: o => {
        set(locationsObject);
    },
    open: (params) => {
        for (let key of Object.keys(locationsObject)) {
            if (params[key]) locationsObject[key] = params[key];
        }
    },
    close: (selected_id = null) => {
        if (selected_id !== null && locationsObject.callback) {
            locationsObject.callback(selected_id);
        }
        locationsObject.tree = null;
        locationsObject.title = "Επιλογή Περιοχής";
        locationsObject.allow_edit = false;
        locationsObject.selected_id = 0;
        locationsObject.multy_select = false;
        locationsObject.hidden_locations = null;
        locationsObject.callback = null;

        locationsObject.edit_id = null;
    }
}

export default locationsStore;